import {Dialog, IconButton} from "@mui/material"
import {useDispatch, useSelector} from "react-redux"
import {
	clearError,
	clearManageWorkspaceView, clearMessage,
	MANAGE_WORKSPACE_VIEW, selectError,
	selectManageWorkspaceView, selectMessage
} from "../../reducers/manageWorkspaceSlice"
import {ManageWorkspaceMembers} from "./ManageWorkspaceMembers"
import ConfigureWorkspacePermissions from "./ConfigureWorkspacePermissions"
import ConfigureNotePermissions from "./ConfigureWorkspaceNotePermissions"
import {UserLookupPanel} from "./UserLookupPanel"
import {ManageWorkspaceInvites} from "./ManageWorkspaceInvites"
import {InviteAuthor} from "./InviteAuthor"
import ConfirmLeaveModal from "./ConfirmLeaveModal"
import TransferOwnership from "./TransferOwnership"
import {useEffect} from "react"
import {useSnackbar} from "notistack"
import {Close} from "@mui/icons-material"
import {
	selectOpenWorkspacePermissions,
	closeWorkspacePermissions
} from "../../reducers/dashboardModalControlSlice"

export function ManageWorkspaceModal() {
	const currentComponent = useSelector(selectManageWorkspaceView)
	const dispatch = useDispatch()
	const workspaceManagementMessage = useSelector(selectMessage)
	const workspaceManagementError = useSelector(selectError)
	const {enqueueSnackbar} = useSnackbar()
	const isOpen = useSelector(selectOpenWorkspacePermissions)

	const closeManageWorkspaceModal = () => {
		dispatch(clearManageWorkspaceView())
		dispatch(closeWorkspacePermissions())
	}

	useEffect(() => {
		if(workspaceManagementMessage) {
			enqueueSnackbar(workspaceManagementMessage, {
				variant: "success",
				autoCloseDuration: 3000,
				onClose: () => {dispatch(clearMessage())}
			})
		}
		if(workspaceManagementError) {
			enqueueSnackbar(workspaceManagementError, {
				variant: "error",
				autoCloseDuration: 3000,
				onClose: () => {dispatch(clearError())}
			})
		}

	}, [workspaceManagementMessage, workspaceManagementError])
	return (
		<Dialog
			open={isOpen}
			onClose={closeManageWorkspaceModal}
			sx={{
				textAlign: "center",
			}}
			PaperProps={{
				sx: {
					width: "60vw",
					maxWidth: "60vw",
					height: "75vh",
					maxHeight: "75vh",
					padding: "2em 2em",
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
				}
			}}
		>
			<IconButton
				aria-label="close"
				onClick={closeManageWorkspaceModal}
				size={"large"}
				sx={{
					position: "absolute",
					height: "unset",
					right: 12,
					top: 12,
				}}
			>
				<Close fontSize={"2em"}/>
			</IconButton>
			{ currentComponent === MANAGE_WORKSPACE_VIEW.MANAGE_MEMBERS && <ManageWorkspaceMembers /> }
			{ currentComponent === MANAGE_WORKSPACE_VIEW.MANAGE_MEMBER && <ConfigureWorkspacePermissions />}
			{ currentComponent === MANAGE_WORKSPACE_VIEW.NOTE_PERMISSIONS && <ConfigureNotePermissions />}
			{ currentComponent === MANAGE_WORKSPACE_VIEW.ADD_NEW_MEMBER && <UserLookupPanel />}
			{ currentComponent === MANAGE_WORKSPACE_VIEW.MANAGE_INVITES && <ManageWorkspaceInvites />}
			{ currentComponent === MANAGE_WORKSPACE_VIEW.INVITE_AUTHOR && <InviteAuthor /> }
			{ currentComponent === MANAGE_WORKSPACE_VIEW.TRANSFER_OWNERSHIP && <TransferOwnership />}
			<ConfirmLeaveModal />
		</Dialog>
	)
}